import { render } from "./ScreenZeroZero.vue?vue&type=template&id=453fa155"
import script from "./ScreenZeroZero.vue?vue&type=script&lang=js"
export * from "./ScreenZeroZero.vue?vue&type=script&lang=js"

import "./ScreenZeroZero.vue?vue&type=style&index=0&id=453fa155&lang=css"

import exportComponent from "/Users/ashrock_m13/Ashrockzzz/git_amrita/virtuallab-oop/exp-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__